// Copyright (c) 2022 by Move Closer.

import { MappingConfig, MappingTypes } from '@movecloser/front-core'

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const addressAdapterMap: MappingConfig = {
  region: {
    type: MappingTypes.Function,
    value: (item) => {
      return {
        region: item.region.name,
        region_id: item.region.id,
        region_code: item.region.code
      }
    }
  }
}
